module.exports = __webpack_public_path__ + "img/youtube.7d1760a9.svg";